<script setup>
import { onMounted, ref } from 'vue';
import { create_report } from '@/services/report';
import editInfo from './editInfo.vue'
import { get_term } from '@/services/terms';
import { useStore } from 'vuex';

const props = defineProps({
  reports: {
    type: Array,
    required: true
  }
})

const store = useStore()
const uploadedFile = ref()
const loading = ref(false)
onMounted(async()=>{
  props.reports.forEach(async (item) => {
    item.attributes.status = await get_status_name(item.attributes.status)
  });
})

async function submitReport(report){
  report.document = uploadedFile.value
  // console.log("🚀 ~ file: download_report.vue:12 ~ submitReport ~ report:", report)
  loading.value = true
  let response = await create_report(report)
  // console.log("🚀 ~ file: download_report.vue:19 ~ submitReport ~ response:", response)
  let tempReport = response.result.data.data.attributes
  report.name = tempReport.name
  report.document = tempReport.document
  report.upload_input = false
  loading.value = false
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.error,
      icon: 'error',
      
    })
  }else{
    Swal.fire({
      title: 'Submitted',
      html: response.result.error,
      icon: 'success',
      confirmButtonText: 'Add Another Report',
      denyButtonText: `View Application`,
      showDenyButton: true,
      reverseButtons: true,
      // allowEscapeKey: false,
      // allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        location.reload()
      }
      // } else if (result.isDenied) {
      //   router.push({name: 'dna-report-application'})
      // }
    })
  }
}

function validateReport(event) {
  const selectedFile = event.target.files[0]; // Get the first selected file
  uploadedFile.value = selectedFile
  if (uploadedFile.value ) {
    // console.log("🚀 ~ file: download_report.vue:20 ~ validateReport ~ uploadedFile.value:", uploadedFile.value)
  }
}



async function downloadReport(report) {
  if (!report.document) return
  
  try {
    const response = await fetch(report.document, {
      headers: {
        'Authorization': localStorage.getItem('uid')
      }
    })
    
    if (!response.ok) throw new Error('Download failed')
    
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = report.name || 'dna_report.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download error:', error)
    Swal.fire({
      title: 'Error',
      text: 'Failed to download file',
      icon: 'error'
    })
  }
}

// need to save on app mounted to reduce retrieving same data
async function get_status_name(term_id){
  let name = 'Error'
  if (term_id == null){
    return name = '-'
  }
  let response = await get_term(term_id)
  // console.log("🚀 ~ get_status_name ~ response:", response)
  if (!response.error){
    name = response.result.data.data.attributes.name
  }else{
    Swal.fire({
      title: 'Error',
      text: 'Error retrieving data',
      icon: 'error'
    })
  }
  return name
}
</script>

<template>
  <div id="download_report" class="card">
    <div class="card-header card-no-border">
      <div class="header-top">
        <h5 class="m-0">Report File</h5>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="border rounded p-2 py-3 row align-items-center mb-2"
        v-for="report in reports"
        :class="report.name == null ? 'unchecked' : 'checked'"
        v-auto-animate
      > 
        <div class="row">
          <div class="col-md-2 col-sm-2">
            <div class="check-btn">
              <vue-feather :type="report.sample_id == '' ? 'x' : 'check'" />
            </div>
          </div>
          <div class="col-md-10 col-sm-10 row px-0 download-content">
            <!-- Info -->
            <div class="col-md-5 col-sm-12 ps-0">
              <p class="mb-0 text-capitalize">{{ report.package_config.options.name.value }}</p>
              <p class="f-light text-ellipsis mb-0">
                {{ report.name == null ? '-' : report.name }}
              </p>
              <!-- Extra Info -->
              <div class="row">
                <p class="mb-0">
                  Status : 
                  <span class="fw-semibold">{{ report.attributes.status }}</span>
                </p>
                <!-- <p class="mb-0">
                  Extra Trait : 
                  <span class="fw-semibold">{{ report.attributes.extra_trait | 0 }}</span>
                </p> -->
              </div>
            </div>

            <!-- Action Button -->
            <div class="col-md-7 col-sm-12 text-left ps-0">
              <div class="flex-center single-child-action">
                <div class="ms-2">
                  <button 
                    class="btn upload-btn icon-btn btn-light-success"
                    :class="report.sample_id == '' ? 'disabled' : ''"
                    @click="report.upload_input = !report.upload_input"
                  >
                    <vue-feather type="upload" size="1rem"/>
                  </button>
                </div>
                <div class="ms-2">
                  <button 
                    @click="downloadReport(report)"
                    class="btn download-btn icon-btn btn-light-success"
                    :class="report.name == null ? 'disabled' : ''"
                    :disabled="report.name == null"
                  >
                    <vue-feather type="download" size="1rem"/>
                  </button>
                </div>
                <div class="ms-2">
                  <button
                    class="btn icon-btn btn-light-warning"
                    data-bs-toggle="modal" :data-bs-target="'#editForm_' + report.id "
                  >
                    <vue-feather type="edit-2" size="1rem"/>
                  </button>
                </div>
                <div class="modal fade" :id="'editForm_' + report.id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <editInfo :report="report" />
                </div>
              </div>
              <p class="single-child-sample text-center f-light text-ellipsis">
                <span class="fw-medium">
                  Sample ID:
                </span> 
                {{ report.sample_id == '' ? '-' : report.sample_id }}
              </p>
            </div>
          </div>
          
        </div>
        <div v-if="report.upload_input" class="row">
          <div class="card shadow-none border">
            <form @submit.prevent="submitReport(report)" class="card-body row">
              <div class="col-md-12">
                <label class="form-label" for="age">DNA report</label>
                <div class="row">
                  <div class="col-md-9">
                    <input 
                      id="upload_input"
                      class="form-control" 
                      type="file" 
                      aria-label="dna report" 
                      required=""
                      @change="validateReport"
                      accept="application/pdf"
                    >
                    <!-- <input 
                      type="file" 
                      accept="application/pdf"
                    > -->
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-light-primary">
                      <span v-if="!loading">Submit</span>
                      <span v-else>
                        <div class="spinner-border spinner-border-sm" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 576px){
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .download-content{
    padding-left: 0.75rem !important;
  }
}
</style>